export default (theme) => ({
    taskRow: {
        display: 'flex',
        alignItems: 'flex-start',
        marginBottom: 20,

        '&:last-child': {
            marginBottom: 0,
        },

        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column'
        },
    },
    taskRow_type: {
        flex: '1 1 20%',
        display: 'flex',
        alignItems: 'center',

        '& .MuiSvgIcon-root': {
            color: '#9e9e9e',
            marginRight: 30,

            [theme.breakpoints.down('sm')]: {
                marginRight: 20,
            },
        },

        [theme.breakpoints.down('sm')]: {
            flex: '1 1 auto',
        },
    },
    taskRow_value: {
        flex: '1 1 80%',

        [theme.breakpoints.down('sm')]: {
            flex: '1 1 auto',
            marginTop: 5,
            marginLeft: 44
        },
    },
    span_button: {
        cursor: 'pointer',
        color: '#3f51b5'
    }
});
